import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import MyButton from '../../util/MyButton';
import {bucket} from '../../util/config';
// MUI Stuff
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import OndemandVideoOutlinedIcon from '@material-ui/icons/OndemandVideoOutlined';
import AddAPhotoRoundedIcon from '@material-ui/icons/AddAPhotoRounded';
// Redux stuff
import {connect} from 'react-redux';
import {postScream, clearErrors} from '../../redux/actions/dataActions';
import {postImage} from '../../redux/actions/userActions';

const styles = theme => ({
  ...theme,
  submitButton: {
    position: 'relative',
    float: 'right',
    marginTop: 10
  },
  progressSpinner: {
    position: 'absolute'
  },
  closeButton: {
    position: 'absolute',
    left: '91%',
    top: '6%'
  },
  input: {
    visibility: 'hidden'
  }
});

class PostScream extends Component {
  state = {
    open: false,
    body: '',
    inputValue: '',
    youtubeUrl: '',
    inputImage: '',
    errors: {},
    inputState: null,
    inputHidden: '',
    buttonHidden: '',
    fileName: ''
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.UI.errors) {
      this.setState({
        errors: nextProps.UI.errors
      });
    }
    if (!nextProps.UI.errors && !nextProps.UI.loading) {
      this.setState({body: '', open: false, errors: {}});
    }
  }

  handleAddVideo = () => {
    this.setState({inputHidden: 'hidden', inputState: true});
  };
  handleAddPhoto = () => {
    this.setState({inputState: null});
    const inputFile = document.querySelector('#uploadImage');
    inputFile.click();
  };

  handleImage = event => {
    if (event.target.files[0]) {
      const image = event.target.files[0];
      this.setState({
        inputState: null,
        buttonHidden: 'hidden',
        fileName: image.name,
        inputHidden: 'hidden'
      });
      const formData = new FormData();
      formData.append('image', image, image.name);
      this.props.postImage(formData);
      this.setState({
        inputImage: `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${image.name}?alt=media`
      });
    } else {
      this.setState({inputState: null, inputHidden: ''});
    }
  };
  handleChangeUrl = event => {
    if (event.target.value) {
      this.setState({inputState: true});
    } else {
      this.setState({inputState: null, inputHidden: ''});
    }
    this.setState({
      inputValue: event.target.value
    });
  };
  handleOpen = () => {
    this.setState({open: true});
  };
  handleClose = () => {
    this.props.clearErrors();
    this.setState({
      open: false,
      errors: {},
      inputState: null,
      inputHidden: '',
      inputImage: '',
      inputValue: '',
      buttonHidden: ''
    });
  };
  handleCloseFile = event => {
    event.target.value = null;
    this.setState({
      inputState: null,
      inputHidden: '',
      fileName: '',
      buttonHidden: '',
      inputImage: ''
    });
  };
  handleCloseUrl = event => {
    event.target.value = null;
    this.setState({inputState: null, inputHidden: '', inputValue: ''});
  };
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };
  handleSubmit = event => {
    event.preventDefault();
    this.props.postScream({
      body: this.state.body,
      youtubeUrl: this.state.inputValue,
      postImage: this.state.inputImage
    });
    this.setState({
      inputState: null,
      inputHidden: '',
      fileName: '',
      buttonHidden: '',
      inputImage: '',
      inputValue: ''
    });
  };

  render() {
    const {errors} = this.state;
    const {
      classes,
      UI: {loading}
    } = this.props;
    return (
      <Fragment>
        <MyButton onClick={this.handleOpen} tip='Post your message'>
          <AddIcon />
        </MyButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth='sm'
        >
          <MyButton
            tip='Close'
            onClick={this.handleClose}
            tipClassName={classes.closeButton}
          >
            <CloseIcon />
          </MyButton>
          <DialogTitle>Post a new message</DialogTitle>
          <DialogContent>
            <form onSubmit={this.handleSubmit}>
              <TextField
                name='body'
                type='text'
                label='Your message'
                multiline
                rows='3'
                placeholder='Post your message'
                error={errors.body ? true : false}
                helperText={errors.body}
                className={classes.textField}
                onChange={this.handleChange}
                fullWidth
              />

              {this.state.inputState === true ? (
                <>
                  {/* Youtube url */}
                  <input
                    onChange={this.handleChangeUrl}
                    type='text'
                    data-url='youtubeUrl'
                    placeholder='enter url'
                    id='youtubeUrl'
                  />
                  <MyButton
                    tip='Close'
                    onClick={this.handleCloseUrl}
                    tipClassName
                  >
                    <CloseIcon />
                  </MyButton>
                </>
              ) : (
                <>
                  <MyButton
                    tip='Add Video'
                    onClick={this.handleAddVideo}
                    btnClassName='button'
                    hidden={this.state.inputHidden}
                  >
                    <OndemandVideoOutlinedIcon
                      hidden={this.state.inputHidden}
                      color='primary'
                    />
                  </MyButton>

                  {/* Upload image */}
                  <input
                    onChange={this.handleImage}
                    data-url='postImage'
                    type='file'
                    id='uploadImage'
                    hidden='hidden'
                  />

                  {this.state.buttonHidden === 'hidden' ? (
                    <>
                      <span>{this.state.fileName}</span>
                      <MyButton
                        tip='Close'
                        onClick={this.handleCloseFile}
                        tipClassName
                      >
                        <CloseIcon />
                      </MyButton>
                    </>
                  ) : (
                    <MyButton
                      tip='Add Photo'
                      onClick={this.handleAddPhoto}
                      btnClassName='button'
                    >
                      <AddAPhotoRoundedIcon
                        hidden={this.state.buttonHidden}
                        color='primary'
                      />
                    </MyButton>
                  )}
                </>
              )}

              <Button
                type='submit'
                variant='contained'
                color='primary'
                className={classes.submitButton}
                disabled={loading}
              >
                Submit
                {loading && (
                  <CircularProgress
                    size={30}
                    className={classes.progressSpinner}
                  />
                )}
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  UI: state.UI
});

// const mapActionsToProps = {uploadPostImage};

PostScream.propTypes = {
  postScream: PropTypes.func.isRequired,
  postImage: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
  postImage,
  postScream,
  clearErrors
})(withStyles(styles)(PostScream));
